//file: rps vrijgavemetingreport version 1.48
function rpsVrijgavemetingReport(d) {
	const a4 = [595.28, 841.89]; // for a4 size paper width and height
	let inspection = d.inspection;
	var resultData = RPSCalculation(d);

	function getNestedProperty(object, property) {
		if (object && typeof object == "object")
			if (typeof property == "string" && property !== "") {
				var split = property.split(".");
				return split.reduce(function (obj, prop) {
					return (obj && obj[prop] || obj[prop] === 0 ? obj && obj[prop] : "-");
				}, object);
			} else if (typeof property == "number") {
				return object[property] || "-";
			}
		return object || "-";
	}

	function getHeader() {
		const num = "V241213_1";
		const hText = (getNestedProperty(inspection, "inspectieDetails.Inspectie_details.Conform_NEN") == true) ?
			"Rapportage eindbeoordeling na asbestverwijdering conform NEN 2990+C1:2020" : "Rapportage eindbeoordeling na asbestverwijdering";
		const header = {
			columns: [
				getProjNumbers(),
				[

					{
						text: hText,
						alignment: 'center',
						fontSize: 11,
						bold: true,
						color: '#000000',
						margin: [-180, 15, 0, 0] //[left, top, right, bottom]
					}


					// {
					// 	text: getProjNumbers(),
					// 	alignment: 'left',
					// 	fontSize: 8,
					// 	bold: false,
					// 	color: '#808080',
					// 	margin: [0, 5, 0, 0]
					// }


				],
				{
					image: 'rpsLogo',
					width: 73.5, // 84 * 0.75
					height: 24.5,  // 52
					margin: [-20, 15, 0, 0]
				}


			]
		};
		return header;
	}

	function getProjNumbers() {
		const projNumbers = {
			columns: [
				{
					width: 90,
					stack: [
						{ text: 'RPS Rapportnummer' },
						{
							text: getReportNumber(true),
							margin: [0, 0, 0, 0]
						}
					]
				},
				{
					width: '*',
					stack: [
						{ text: '' },
						{ text: '', margin: [0, 0, 0, 0] }
					]
				}
			],
			fontSize: 7,
			color: '#808080',
			margin: [19, 16, 0, 0] // [27, 4, 0, 0])
			,
			pageBreak: ''
		};
		return projNumbers;
	}

	function getReportNumber(header = false) {
		var monstNum = getNestedProperty(inspection, "inspectieDetails.Inspectie_details.rPSMonsternummer");

		var revisionNum = (inspection.correctionCount ? (((inspection.correctionCount + 1) < 10 ? '0' : '') + (inspection.correctionCount + 1)) : '01');

		if (header && inspection.correctionCount && inspection.correctionCount > 0) {
			var previousRevNum = ((inspection.correctionCount < 10 ? '0' : '') + (inspection.correctionCount));
			var repNum = monstNum + "_" + revisionNum + " (vervangt " + monstNum + "_" + previousRevNum + ")";
			return repNum;
		} else {
			var repNum = monstNum + "_" + revisionNum;
			return repNum;
		}
	}

	function getFooter(currentPage, pageCount, pageSize) {
		const footer = {
			columns: [
				{
					stack:
						[
							{
								text: "Voor het verrichten van eindbeoordelingen na verwijdering van asbesthoudende materialen conform NEN 2990+C1:2020 is RPS analyse bv geaccrediteerd door de Raad voor Accreditatie, registratie onder nummer I143 Inspectie.",
								style: "text",
								alignment: 'left',
								margin: [0, 5, 0, 15]
							}

						],
					width: '*'
				},
				{
					text: "Pagina " + currentPage.toString() + " van " + pageCount,
					style: "text",
					width: 100,
					margin: [5, 5, 5, 0],
					alignment: 'left'
				},
			],
			margin: [15, 0, 0, 0]
		};

		return footer;
	}

	function getFirtsPageTop(data, insp) {
		var timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
		return {
			columns: [
				{
					width: '*',
					stack: [
						{
							stack: [
								{ text: getNestedProperty(insp, "Inspectie_info.Klant_gegevens.opdrachtgever"), margin: [0, 0, 0, 0] },
								{
									text: (insp.Inspectie_info.Klant_gegevens.Straat) ?
										(insp.Inspectie_info.Klant_gegevens.Straat + " " + (insp.Inspectie_info.Klant_gegevens.Huisnummer || "")) : "", margin: [0, 3, 0, 0]
								},
								{
									text: (insp.Inspectie_info.Klant_gegevens.Postcode && insp.Inspectie_info.Klant_gegevens.Plaats) ?
										(insp.Inspectie_info.Klant_gegevens.Postcode + " " + insp.Inspectie_info.Klant_gegevens.Plaats) : "", margin: [0, 3, 0, 0]
								}
							],
							fontSize: 10,
							margin: [81, 74, 0, 0]
						},
						{
							columns: [
								{
									width: 112,
									stack: [
										{ text: 'RPS rapportnummer', margin: [0, 4, 0, 0] },
										{ text: 'RPS projectnummer', margin: [0, 4, 0, 0] },
										{ text: 'RPS monsternummer', margin: [0, 4, 0, 0] }
									],
									bold: true,
									margin: [0, 0, 0, 0]
								},
								{
									width: '*',
									stack: [
										{ text: getReportNumber(), margin: [0, 4, 0, 0] },
										{ text: getNestedProperty(insp, "Inspectie_info.inspectieInfo.rPSProjectnummer"), margin: [0, 4, 0, 0] },
										{ text: getNestedProperty(insp, "inspectieDetails.Inspectie_details.rPSMonsternummer"), margin: [0, 4, 0, 0] }
									],
									margin: [0, 0, 0, 0]
								},
								{
									width: 112,
									stack: [
										{ text: 'Datum inspectie', margin: [0, 4, 0, 0] },
										{ text: 'Datum rapportage', margin: [0, 4, 0, 0] },

									],
									bold: true,
									margin: [0, 0, 0, 0]
								},
								{
									width: '*',
									stack: [
										{
											text: insp.Inspectie_info.inspectieInfo.Datum_meting___inspectie ?
												(new Date(insp.Inspectie_info.inspectieInfo.Datum_meting___inspectie).toLocaleDateString('nl-NL')) :
												"", margin: [0, 4, 0, 0]
										},
										{ text: new Date().toLocaleDateString('nl-NL'), margin: [0, 4, 0, 0] }
									],
									margin: [0, 0, 0, 0]
								}
							],
							fontSize: 8,
							margin: [18, 50, 0, 0]
						}
					]
				},
				{
					width: 91,
					stack: [
						{ text: 'RPS analyse bv', style: 'gray-header', margin: [0, 12, 0, 0] },
						{
							text: [
								{ text: 'E ' },
								{ text: ' ' },
								{ text: 'analyse@RPS.nl', link: 'mailto:analyse@RPS.nl', style: 'link' }
							],
							style: 'gray-text',
							margin: [0, 6, 0, 0]
						},
						{
							text: [
								{ text: 'W ' },
								{ text: ' ' },
								{ text: 'www.rps.nl', link: 'www.rps.nl', style: 'link' }
							],
							style: 'gray-text',
							margin: [0, -1, 0, 0]
						},
						{ text: 'Breda', style: 'gray-header', margin: [0, 18, 0, 0] },
						{ text: 'Minervum 7002', style: 'gray-text', margin: [0, 11, 0, 0] },
						{ text: 'Postbus 3440', style: 'gray-text', margin: [0, -1, 0, 0] },
						{ text: '4800 DK Breda', style: 'gray-text', margin: [0, -1, 0, 0] },
						{ text: 'T 088 99 04 710', style: 'gray-text', margin: [0, 7, 0, 0] },
						{ text: 'Zwolle', style: 'gray-header', margin: [0, 23, 0, 0] },
						{ text: 'Ampèrestraat 35', style: 'gray-text', margin: [0, 10, 0, 0] },
						{ text: 'Postbus 40172', style: 'gray-text', margin: [0, -1, 0, 0] },
						{ text: '8004 DD Zwolle', style: 'gray-text', margin: [0, -1, 0, 0] },
						{ text: 'T 088 99 04 750', style: 'gray-text', margin: [0, 7, 0, 0] },
					]
					, margin: [0, 0, 15, 0]
				}
			]
		};
	}

	function getFirtsPageMiddle(insp) {
		var timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
		const tables = {
			first: [
				{ l: 'Adres projectlocatie', v: getNestedProperty(insp, "inspectieDetails.Inspectie_details.adresMetinginspectie") },
				{ l: 'Omschrijving inspectiegebied', v: getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Omschrijving_inspectiegebied") },
				{ l: 'Projectnummer opdrachtgever', v: getNestedProperty(insp, "Inspectie_info.inspectieInfo.Projectnummer_opdrachtgever") },
				{ l: 'Doelstelling', v: 'Vrijgavemeting' },
				{ l: 'Conform NEN2990+C1:2020', v: (getNestedProperty(insp, "inspectieDetails.Inspectie_details.Conform_NEN") == true) ? "Ja" : "Nee" },
				{ l: 'Aard van sanering', v: getNestedProperty(insp, "inspectieDetails.Inspectie_details.Aard_van_sanering") },
				{ l: 'Naam DTA/opdrachtgever', v: getNestedProperty(insp, "inspectieDetails.Inspectie_details.Naam_DTA_Opdrachtgever") }


			],
			second: [
				{ l: 'Naam inspecteur', v: getNestedProperty(insp, "inspectieDetails.Inspectie_details.laborantinspecteur") },
				{
					l: 'Aanwezig op locatie vanaf', v: insp.Inspectie_info.inspectieInfo.Aanwezig_op_locatie_vanaf_ ?
						new Date(insp.Inspectie_info.inspectieInfo.Aanwezig_op_locatie_vanaf_).toLocaleTimeString('nl-NL', timeOptions) : ""
				},
				{
					l: 'Aanwezig op locatie tot', v: insp.Inspectie_info.inspectieInfo.Aanwezig_op_locatie_tot_ ?
						new Date(insp.Inspectie_info.inspectieInfo.Aanwezig_op_locatie_tot_).toLocaleTimeString('nl-NL', timeOptions) : ""
				},
				{ l: 'Aantal luchtpompen', v: getNestedProperty(insp, "Inspectie_info.inspectieInfo.totaalAantalPompen") },
				{ l: 'Aantal goudfilters', v: getNestedProperty(insp, "Inspectie_info.inspectieInfo.aantalGoudfiltersVoorSEM") },
				{ l: 'Aantal kleefmonsters', v: getNestedProperty(insp, "Inspectie_info.inspectieInfo.Aantal_kleefmonsters") },
				{ l: 'Aantal grondmonsters', v: getNestedProperty(insp, "Inspectie_info.inspectieInfo.aantalGrondmonsters") },
				{ l: 'Aantal materiaalmonsters', v: getNestedProperty(insp, "Inspectie_info.inspectieInfo.aantalMateriaalmonsters") }
			]
		};

		const getLine = (margin) => {
			return {
				canvas: [
					{
						type: "line",
						x1: 16,
						y1: 1,
						x2: a4[0] - 30,
						y2: 1,
						lineWidth: 0.5
					}
				],
				margin: margin
			};
		};

		const mapTableRow = (i, idx) => {
			const m1 = [0, idx === 0 ? 0 : 0.5, 0, 0];
			const m2 = [...m1];
			if (i.l.length > 30) {
				m2[1] += 4;
			}
			return [{ text: i.l, bold: true, margin: m1 }, { text: i.v, margin: m2 }];
		};

		return [
			getLine([0, 12, 0, 0]),
			{
				columns: [
					{
						width: 352,
						table: {
							headerRows: 0,
							widths: [99, '*'],
							body: tables.first.map(mapTableRow)
						},
						layout: 'noBorders',
						margin: 0
					},
					{
						width: 205,
						table: {
							headerRows: 0,
							widths: [118, '*'],
							body: tables.second.map(mapTableRow)
						},
						layout: 'noBorders',
						margin: 0
					}
				],
				fontSize: 8,
				margin: [18, 10, 0, 0]
			},
			getLine([0, 10, 0, 0])
		];
	}

	function getGrayHeaderTable(table) {
		const headerRow = table.header.labels.map((i, idx) => {
			const marginTop = table.header.marginsTop && table.header.marginsTop[idx] != undefined
				? table.header.marginsTop[idx] : 0;
			return { text: i, margin: [0, marginTop, 0, 0], bold: true, lineHeight: 0.9 };
		});
		const dataRows = table.data.map((row) => {
			return row.map(cell => {
				return { text: cell, fontSize: table.dataFontSize != undefined ? table.dataFontSize : 8 };
			});
		});
		const body = [headerRow].concat(dataRows);
		return {
			table: {
				headerRows: 1,
				widths: table.header.widths,
				body: body
			},
			layout: {
				paddingLeft: function (i, node) { return 1; },
				paddingRight: function (i, node) { return 1; },
				paddingTop: function (i, node) { return 2; },
				paddingBottom: function (i, node) { return 2; },
				fillColor: function (i, node) { return (i === 0) ? '#CCCCCC' : null; }
			},
			fontSize: 8,
			margin: table.tableMargin
		};
	}

	function getFirstPageTables(insp) {

		//var amountOfToepassingen = insp.toepassingen.length;
		var toepassingenData = [];
		if (insp.toepassingen) {
			for (var t of insp.toepassingen) {
				let asbestsoortenAndPercentage = [
					(t.asbestsoort1 ? t.asbestsoort1 + ", " + (t.percentage1) : ""),
					(t.asbestsoort2 ? t.asbestsoort2 + ", " + (t.percentage2) : ""),
					(t.asbestsoort3 ? t.asbestsoort3 + ", " + (t.percentage3) : "")
				];
				toepassingenData.push(
					[
						t.verwijderdMateriaal,
						t.broncode,
						t.hoeveelheidVerwijderdMateriaal,
						t.bouwEnConstructiedeel,
						asbestsoortenAndPercentage.join("\n"),
						t.Hechtgebondenheid,
						t.Bevestigingsmethode,
						t.risicoklasseConstructiedeel
					]
				);
			}
		}

		const t1 = {
			header: {
				widths: [107, 38, 47, 106, 90, 40, 46, 51],
				labels: [
					'Materiaal', 'Broncode', 'Hoeveelheid', 'Bouwdeel', 'Soort asbest en percentage', 'Hechtgeb.',
					'Bevestiging', 'Risicoklasse'
				],
				marginsTop: [4, 4, 4, 4, 0, 4, 4, 4]
			},
			data: toepassingenData,
			dataFontSize: 6,
			tableMargin: [16, 13, 0, 0]
		};
		const t2 = { 
			header: {
				widths: '*',
				labels: ['Algemene opmerkingen betreffende het project']
			},
			data: [[insp.Inspectie_info.inspectieInfo.Algemene_opmerkingen_project_sanering]],
			tableMargin: [16, 12, 9.5, 0]
		};
		const t3 = {
			header: {
				widths: '*',
				labels: ['Conclusie']
			},
			data: [[generateConclusion(insp)]],
			tableMargin: [16, 8, 9.5, 0]
		};

		function generateConclusion(insp) {
			var conclusion = "";
			var afwijkendeConclusie = getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Afwijkende_conclusie");
			if (afwijkendeConclusie != "-" && afwijkendeConclusie != " ") {
				conclusion = afwijkendeConclusie;
				return conclusion;
			}
			if (insp.pompen) {
				for (var p of insp.pompen) {
					if ( p.aantalGeteldeVelden == undefined ||
						p.aantalGeteldeVezels == undefined ||
						p.aantalGeteldeVelden == undefined ||
						p.flowNaLmin == undefined ||
						p.flowVoorLmin == undefined ||
						p.pomptijdMinuten == undefined ||
						p.waardeFlowmeterNaLmin == undefined ||
						p.waardeFlowmeterVoorlmin == undefined) {
						conclusion = " "
						return conclusion;
					}
				}
			}

			if (insp.pompen) {
				for (var p of insp.pompen) {
					if (p.filteroverbeladenSEM == "Overbeladen") {
						conclusion = "Een of meerdere filters zijn overbeladen.";
						return conclusion;
					}
					if (p.filteroverbeladenSEM == "SEM") {
						conclusion = "Conclusie is afhankelijk van SEM";
						return conclusion;
					}
				}
			}

			var afgekeurd = false;
			if (insp.Segmenten) {
				insp.Segmenten.forEach((segment, index) => {
					const afgekeurdText = "Afgekeurd, ruimte opnieuw reinigen";
					if (segment.Bron) {
						for (let bronIdx in segment.Bron) {
							if (segment.Bron[bronIdx].Constructiedeel == afgekeurdText ||
								segment.Bron[bronIdx].Resultaat_aangelegen_delen == afgekeurdText ||
								segment.Bron[bronIdx].Resultaat_ondergelegen_opp == afgekeurdText) {
								afgekeurd = true;
							}
						}
					}

					if (segment.Overige_bouw__en_constructiedelen) {
						if (segment.Overige_bouw__en_constructiedelen.Buizen == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Deco_unit__gereedschap__hulpmiddelen__etc_ == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Kabelgoten___doorvoeringen == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Kozijnen == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Machines__installaties == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Plafond == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Plinten == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Route_afvoer_afval == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Ventilatiekanalen == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Verwarmingselementen == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Vloer == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Waarde_overig == afgekeurdText) {
							afgekeurd = true;
						}
					}

				})
			}


			var somVolumeIsZero = true;
			if (insp.pompen) {
				for (var p of insp.pompen) {
					if (p.flowVoorLmin > 0 && p.flowNaLmin > 0 && p.pomptijdMinuten > 0) {
						somVolumeIsZero = false;
					}
				}
			}

			if (somVolumeIsZero && afgekeurd == false) {
				conclusion = "   ";
				return conclusion;
			}

			if ((resultData.eindconcentratie == "<10000" && afgekeurd == false) && insp.inspectieDetails.Inspectie_details.Conform_NEN && 
			insp.vezeltelling.vezeltelling.Zijn_de_filters_homogeen_beladen_) {
				conclusion = "Op het moment van de eindbeoordeling kan geconcludeerd worden dat het omschreven inspectiegebied voldoet aan de eisen zoals gesteld in NEN 2990+C1:2020.";
				return conclusion;
			} else {
				conclusion = "Op het moment van de eindbeoordeling kan geconcludeerd worden dat het omschreven inspectiegebied en / of de achterblijvende toepassing(en) NIET voldoet aan de eisen zoals gesteld in NEN 2990+C1:2020."
				return conclusion;
			}
		}

		return [
			getGrayHeaderTable(t1),
			getGrayHeaderTable(t2),
			getGrayHeaderTable(t3)
		];
	}

	function getFirstPageBottom(data) {
		let inspectorSignature = data.signature || rpsLogo();
		let clientSignatureObj = {};
		let clientSignature = (data.drawings || []).find(d => d.propertyName === 'signature');
		if (clientSignature) {
			clientSignatureObj = {
				image: clientSignature && clientSignature.dataUrl ? clientSignature.dataUrl : null,
				fit: [120, 70],
				alignment: 'left'
			};
		}

		return {
			columns: [
				{
					width: '*',
					stack: [
						{ text: 'Naam DTA/opdrachtgever:' },
						{ text: getNestedProperty(data, "inspection.inspectieDetails.Inspectie_details.Naam_DTA_Opdrachtgever"), margin: [0, 6, 0, 0] },
						clientSignatureObj
					],
					style: 'text',
					margin: [26, 17, 0, 0]
				},
				{
					width: 135,
					stack: [
						{ text: 'Meting uitgevoerd door:', margin: [5, 0, 0, 0] },
						{ text: getNestedProperty(data, "inspection.inspectieDetails.Inspectie_details.laborantinspecteur"), margin: [5, 5, 0, 0] },
						{
							image: inspectorSignature,
							fit: [120, 70],
							alignment: 'center'
						}
					],
					style: 'text',
					margin: [0, 16, 6, 0]
				}
			]
		};
	}


	function getRandvoorwaardenPage(insp) {
		const projectDocTitle =
		{
			text: 'Projectdocumentatie:',
			alignment: 'left',
			fontSize: 10,
			bold: true,
			color: '#000000',
			margin: [18, 8, 0, 0],
			pageBreak: 'before'

		};

		const projectDocData = [
			{ l: 'Werkplannummer', v: getNestedProperty(insp, "inspectieDetails.Inspectie_details.werkplanNr") },
			{ l: 'Inventarisatiebureau', v: getNestedProperty(insp, "inspectieDetails.Inspectie_details.inventarisatieBureau") },
			{ l: 'Inventarisatierapportnummer +  versie', v: getNestedProperty(insp, "inspectieDetails.Inspectie_details.inventarisatieRapportnr") },
			{ l: 'Referentie sloopmelding/omgevingsvergunning', v: getNestedProperty(insp, "inspectieDetails.Inspectie_details.sloopmeldingomgevingsvergunningNr") },
			{
				l: 'Melding CI/gemeente/Inspectie SZW', v: insp.inspectieDetails.Inspectie_details.meldingNaarCIgemSZWGeldigTm ?
					(new Date(insp.inspectieDetails.Inspectie_details.meldingNaarCIgemSZWGeldigTm).toLocaleDateString('nl-NL')) : ""
			},
			{ l: 'Conform', v: getNestedProperty(insp, "toepassingen.0.conform") },
			{ l: 'Onderdruk verlaagd:', v: getNestedProperty(insp, "inspectieDetails.Inspectie_details.Onderdruk_verlaagd") },
			{ l: 'Opmerkingen projectdocumentatie', v: getNestedProperty(insp, "inspectieDetails.Inspectie_details.Opmerking_en_") }
		];

		const mapTableRow = (i, idx) => {
			const m1 = [0, idx === 0 ? 0 : 0.5, 0, 0];
			const m2 = [...m1];
			if (i.l.length > 30) {
				m2[1] += 0; //changed to += 0 instead of 4, to align all rows nicely
			}
			return [{ text: i.l, bold: true, margin: m1 }, { text: i.v, margin: m2 }];
		};

		const conditionsTableRender =
		{
			columns: [
				{
					width: 452,
					table: {
						headerRows: 0,
						widths: [200, '*'],
						body: projectDocData.map(mapTableRow)
					},
					layout: 'noBorders',
					margin: 0
				}
			],
			fontSize: 8,
			margin: [18, 10, 0, 0],
			border: true
		};


		const inspectionAreaTitle =
		{
			text: 'Inspectiegebied:',
			alignment: 'left',
			fontSize: 10,
			bold: true,
			color: '#000000',
			margin: [18, 15, 0, 0]
		};

		const inspectionAreaTableData = [
			{ l: 'Grootte inspectiegebied m²', v: getNestedProperty(insp, "visueleInspectie.Inspectiegebied.grootteInspectiegebiedM2") },
			{ l: 'Inhoud containment m³', v: getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Inhoud_containment__m3_") },
			{
				l: 'Decontaminatie-unit of -sluis aanwezig?', v: insp.visueleInspectie.Inspectiegebied.decoUnitAanwezig ?
					(insp.visueleInspectie.Inspectiegebied.decoUnitAanwezig == true ? "Ja" : "Nee") : "Nee"
			},
			{ l: 'Werkt de decontaminatie-unit/-sluis naar behoren?', v: getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Werkt_deco_unit_goed_") },
			{
				l: 'Inspectiegebied juist afgezet?', v: insp.visueleInspectie.Inspectiegebied.Inspectiegebied_juist_afgezet ?
					(insp.visueleInspectie.Inspectiegebied.Inspectiegebied_juist_afgezet == true ? "Ja" : "Nee") : "Nee"
			},
			{
				l: 'Inspectiegebied voldoende verlicht?', v: insp.visueleInspectie.Inspectiegebied.inspectgebiedGoedVerlicht ?
					(insp.visueleInspectie.Inspectiegebied.inspectgebiedGoedVerlicht == true ? "Ja" : "Nee") : "Nee"
			},
			{ l: 'Deugdelijke materialen/machines voor werken op hoogte aanwezig?', v: getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Deugdelijk_klimmat__aanwezig_") }
		];

		const inspectionAreaTableRender = {
			columns: [
				{
					width: 452,
					table: {
						headerRows: 0,
						widths: [200, '*'],
						body: inspectionAreaTableData.map(mapTableRow)
					},
					layout: 'noBorders',
					margin: 0
				}
			],
			fontSize: 8,
			margin: [18, 10, 0, 0]
		};

		return [
			projectDocTitle,
			conditionsTableRender,
			inspectionAreaTitle,
			inspectionAreaTableRender
		];
	}


	function getTimeFrommilisecs(millisec) {
		var seconds = (millisec / 1000).toFixed(0);
		var minutes = Math.floor(seconds / 60);
		var hours = "";
		if (minutes > 59) {
			hours = Math.floor(minutes / 60);
			hours = (hours >= 10) ? hours : "0" + hours;
			minutes = minutes - (hours * 60);
			minutes = (minutes >= 10) ? minutes : "0" + minutes;
		}

		if (hours != "") {
			return hours + ":" + minutes;
		}
		return minutes;
	}

	function getVisualInspectionPage(insp) {
		var timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
		const visualInspTitle =
		{
			text: 'Resultaten visuele inspectie:',
			alignment: 'left',
			fontSize: 10,
			bold: true,
			color: '#000000',
			margin: [18, 8, 0, 0],
			pageBreak: 'before'

		};

		const visualInspData = [
			{ l: 'Totale inspectietijd (min)', v: getNestedProperty(insp, "visueleInspectie.Inspectiegebied.inspectietijdMin") },
			{
				l: 'Starttijd inspectie', v: getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Starttijd_inspectie") ?
					new Date(getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Starttijd_inspectie")).toLocaleTimeString('nl-NL', timeOptions) : ""
			},
			{
				l: 'Luchtvochtigheid containment (%)', v: (getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Luchtvochtigheid_containment____") == " ") ? "-" :
					getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Luchtvochtigheid_containment____")
			},
			{
				l: 'Luchtvochtigheid omliggende ruimte(s) (%)', v: (getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Luchtvochtigheid_omligg__ruimten____") == " ") ? "-" :
					getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Luchtvochtigheid_omligg__ruimten____")
			}
		];

		const mapTableRow = (i, idx) => {
			const m1 = [0, idx === 0 ? 0 : 0.5, 0, 0];
			const m2 = [...m1];
			if (i.l.length > 30) {
				m2[1] += 0;
			}
			return [{ text: i.l, bold: true, margin: m1 }, { text: i.v, margin: m2 }];
		};

		const visualInspTableRender =
		{
			columns: [
				{
					width: 452,
					table: {
						headerRows: 0,
						widths: [200, '*'],
						body: visualInspData.map(mapTableRow)
					},
					layout: 'noBorders',
					margin: 0
				}
			],
			fontSize: 8,
			margin: [18, 10, 0, 0]
		};


		const t1 = {
			header: {
				widths: '*',
				labels: ['Resultaat visuele inspectie']
			},
			data: [[generateEindresultaat()]],
			tableMargin: [16, 8, 9.5, 0]
		};
		const t2 = {
			header: {
				widths: '*',
				labels: ['Visuele beperkingen/uitsluitingen']
			},
			data: [[getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Visuele_beperkingen")]],
			tableMargin: [16, 8, 9.5, 0]
		};
		const t3 = {
			header: {
				widths: '*',
				labels: ['Achterblijvende asbestverdachte/-houdende materialen in en/of rondom containment/inspectiegebied']
			},
			data: [[getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Achterblijvende_asbesthoudende_of_asbestverdachte_materialen_inclusief_vorm")]],
			tableMargin: [16, 8, 9.5, 0]
		};
		const t4 = {
			header: {
				widths: '*',
				labels: ['Opmerkingen betreffende de visuele inspectie']
			},
			data: [[
				getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Aanvullende_opmerking___locatie_kleef__grondmonsters")
				+ (getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Douche_sluis_maakt_deel_uit_van_inspectiegebied") == true ?
					"\n De vuile ruimte van de douchesluis maakt deel uit van het inspectiegebied." : "")
				+ (getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Decontaminatie_unit_maakt_deel_uit_van_inspectiegebied") == true ?
					"\n De vuile ruimte van de decontaminatie-unit maakt deel uit van het inspectiegebied. " : "")
				+ (getNestedProperty(insp, "visueleInspectie.Inspectiegebied.Visuele_inspectie.Transitsluis_en_route_maakt_deel_uit_van_inspectiegebied") == true ?
					"\n De transitsluis en -route  maken deel uit van het inspectiegebied. " : "")
				+ (getNestedProperty(insp, "inspectieDetails.Inspectie_details.Te_klein_containment") == true ?
					"\n Wegens een te klein containment is er afgeweken van de voorgeschreven meetopstelling. " : "")
			]],
			tableMargin: [16, 8, 9.5, 0]
		};


		function generateEindresultaat() {
			var eindresultaat = " ";
			var geenMetingUitgevoerd = false;
			if (getNestedProperty(insp, "inspectieDetails.Inspectie_details.GEEN_meting_uitgevoerd___visueel_afgekeurd") == true) {
				geenMetingUitgevoerd = true;
			}

			var afgekeurd = false;
			if (insp.Segmenten) {
				insp.Segmenten.forEach((segment, index) => {
					const afgekeurdText = "Afgekeurd, ruimte opnieuw reinigen";
					if (segment.Bron) {
						for (let bronIdx in segment.Bron) {
							if (segment.Bron[bronIdx].Constructiedeel == afgekeurdText ||
								segment.Bron[bronIdx].Resultaat_aangelegen_delen == afgekeurdText ||
								segment.Bron[bronIdx].Resultaat_ondergelegen_opp == afgekeurdText) {
								afgekeurd = true;
							}
						}
					}

					if (segment.Overige_bouw__en_constructiedelen) {
						if (segment.Overige_bouw__en_constructiedelen.Buizen == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Deco_unit__gereedschap__hulpmiddelen__etc_ == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Kabelgoten___doorvoeringen == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Kozijnen == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Machines__installaties == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Plafond == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Plinten == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Route_afvoer_afval == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Ventilatiekanalen == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Verwarmingselementen == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Vloer == afgekeurdText ||
							segment.Overige_bouw__en_constructiedelen.Waarde_overig == afgekeurdText) {
							afgekeurd = true;
						}
					}

				})
			}

			if (geenMetingUitgevoerd && afgekeurd != true) {
				return eindresultaat;
			}
			if (geenMetingUitgevoerd == false && afgekeurd != true) {
				eindresultaat = "Het omschreven inspectiegebied voldoet visueel aan de eisen zoals gesteld in NEN 2990+C1:2020."
				return eindresultaat;
			} else {
				eindresultaat = "Het omschreven inspectiegebied voldoet visueel NIET aan de eisen zoals gesteld in NEN 2990+C1:2020."
				return eindresultaat;
			}

		}

		return [
			visualInspTitle,
			visualInspTableRender,
			getGrayHeaderTable(t1),
			getGrayHeaderTable(t2),
			getGrayHeaderTable(t3),
			getGrayHeaderTable(t4)
		]
	}

	function getSegment(segmentData, idx) {
		const segment = [
			{
				text: '',
				fontSize: 8,
				margin: (idx == 0 ? [27, 30, 0, 0] : [27, 4, 0, 0]),
				pageBreak: ((idx == 0 || (idx % 2 == 0)) ? '' : 'before')
			}

		];
		segment.push({ text: segmentData.header1.text, style: 'segment-header', margin: segmentData.header1.margin });

		if (segmentData.header2) {
			segment.push(
				{ text: segmentData.header2.text, style: 'segment-header', margin: segmentData.header2.margin }
			);
		}

		const t1HeaderRow = segmentData.table1.headers.map(i => ({ text: i, bold: true }));
		const t1Data = segmentData.table1.data;
		const t1DataRows = t1Data.map((row) => {
			return row.map(cell => {
				return { text: cell, fontSize: 6 };
			});
		});
		const t1Body = [t1HeaderRow].concat(t1DataRows);

		segment.push({
			table: {
				headerRows: 1,
				widths: segmentData.table1.widths,
				body: t1Body
			},
			layout: {
				paddingLeft: function (i, node) { return i === 0 ? 2 : 1.5; },
				paddingRight: function (i, node) { return i === 0 ? 2 : 1.5; },
				paddingTop: function (i, node) { return i === 0 ? 2.5 : 1.5; },
				paddingBottom: function (i, node) { return i === 0 ? 2.5 : 1.5; }
			},
			fontSize: 8,
			margin: [19, 2, 8, 0]
		});

		const t2HeaderRow = segmentData.table2.headers.map(i => ({ text: i, bold: true }));
		const t2Data = segmentData.table2.data;
		const t2DataRows = t2Data.map((row) => {
			return row.map(cell => {
				if (typeof cell === "object") {
					return { text: cell.text, fontSize: 6, rowSpan: cell.rowSpan }
				}
				return { text: cell, fontSize: 6 };
			});
		});
		const t2Body = [t2HeaderRow].concat(t2DataRows);
		segment.push({
			table: {
				headerRows: 1,
				widths: segmentData.table2.widths,
				body: t2Body
			},
			layout: {
				paddingLeft: function (i, node) { return i === 0 ? 2 : 1.5; },
				paddingRight: function (i, node) { return i === 0 ? 2 : 1.5; },
				paddingTop: function (i, node) { return i === 0 ? 2.5 : 1.5; },
				paddingBottom: function (i, node) { return i === 0 ? 2.5 : 1.5; }
			},
			fontSize: 8,
			margin: [19, 10, 8, 0]
		});
		return segment;
	}


	function getSegmentsPages(insp) {
		const t1Widths = [112, 87, 86, 86, 153];
		const t1Headers = [
			'Verwijderde toepassing + (broncode)',
			'Resultaat constructiedeel',
			'Resultaat aangelegen delen',
			'Resultaat ondergelegen oppervlak',
			'Opmerking'
		];

		const t2Widths = [112, 87, 333];
		const t2Headers = [
			'Overige bouw- en constructiedelen',
			'Resultaat',
			'Opmerking(en) overige bouw- en constructiedelen'
		];


		var segmentData = [];
		if (insp.Segmenten) {
			insp.Segmenten.forEach((segment, index) => {
				var bronnenData = [];
				if (segment.Bron) {
					for (let bronIdx in segment.Bron) {
						if (segment.Bron[bronIdx].Bronnaam) {
							bronnenData.push(
								{
									keyName: bronIdx,
									bron: [
										segment.Bron[bronIdx].Bronnaam,
										segment.Bron[bronIdx].Constructiedeel,
										segment.Bron[bronIdx].Resultaat_aangelegen_delen,
										segment.Bron[bronIdx].Resultaat_ondergelegen_opp,
										(segment.Bron[bronIdx].Opmerkingen || "geen")
									]
								}
							);
						}
					}
				}
				bronnenData = bronnenData.sort(function (a, b) { return a.keyName - b.keyName });
				let segBronData = [];
				for (let f in bronnenData) {
					segBronData.push(bronnenData[f].bron);
				}

				segmentData.push(
					{
						header1: {
							text: "Segment" + " " + (index + 1),
							margin: [27, 5, 0, 0]
						},
						header2: {
							text: getNestedProperty(segment, "Segment_naam"),
							margin: [27, -2, 0, 0]
						},
						table1: {
							widths: t1Widths,
							headers: t1Headers,
							data: segBronData
						},
						table2: {
							widths: t2Widths,
							headers: t2Headers,
							data: [
								['Plafond (constructiedelen)', getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Plafond"), { rowSpan: 12, text: getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Opmerkingen") }],
								['Kabelgoten en/of doorvoeringen', getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Kabelgoten___doorvoeringen"), ''],
								['Ventilatiekanalen', getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Ventilatiekanalen"), ''],
								['Buizen', getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Buizen"), ''],
								['Verwarmingselementen', getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Verwarmingselementen"), ''],
								['Kozijnen', getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Kozijnen"), ''],
								['Plinten', getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Plinten"), ''],
								['Vloer', getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Vloer"), ''],
								['Machines, installaties', getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Machines__installaties"), ''],
								[(getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Naam_overig_") || " "), (getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Waarde_overig") || " "), ''],
								['Deco-unit, gereedschappen en hulpmiddelen, stellingmateriaal, trappen, steigers en eventueel achtergebleven inboedel', getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Deco_unit__gereedschap__hulpmiddelen__etc_"), ''],
								['Route waarlangs het afval is afgevoerd, transit-route', getNestedProperty(segment, "Overige_bouw__en_constructiedelen.Route_afvoer_afval"), '']
							]
						}
					}

				);


			})
		}

		const result = segmentData.map((s, idx) => {
			const segmentRender = [];
			segmentRender.push(getSegment(s, idx));
			return segmentRender;
		});
		return result;
	}

	function getPumpTableRow(startNum, pumpsData, marginsTop, insp) {
		//skipping pumps 16-20 if they are empty to fit on 1 page
		if (startNum == 16 && insp.pompen && (insp.pompen.filter(e => e.pompnummer > 15).length == 0)){
			return;
		}
		const tableHeaderRow = Array.from(Array(10)).map((i, idx) => {
			if (idx === 0) return { text: ' ', border: [false, false, true, true] };
			if (idx % 2 === 0) return { text: ' ' };
			return { text: 'Pomp ' + (idx - (idx / 2 + 0.5) + startNum), bold: true, alignment: 'center' };
		});
		const tableDataRows = [
			'Filter overbeladen / SEM',
			'Aantal getelde velden',
			'Pomptijd (min)',
			'Flow voor (l/min)',
			'Flow na (l/min)',
			'Bemonsterd volume lucht (l)',
			'Aantal getelde vezels',
			'Vezelconcentratie (Vz/m³)',
			'Concentratie ondergrens (Vz/m³)',
			'Concentratie bovengrens (Vz/m³)',
			'Eindconcentratie (Vz/m³)'	
		].map((row, idx) => {
			return Array.from(Array(10)).map((r_i, r_idx) => {
				if (r_idx === 0) {
					return { text: row };
				}
				const pumpIndex = (r_idx - (r_idx / 2 + 0.5));
				return (r_idx % 2 === 0)
					? { text: '' }
					: { text: (pumpsData[pumpIndex] && (pumpsData[pumpIndex][idx] !== undefined)) ? pumpsData[pumpIndex][idx] : '-', alignment: 'center' };
			});
		});
		const tableBody = [tableHeaderRow].concat(tableDataRows);

		return {
			table: {
				headerRows: 1,
				widths: [130, 69, 1.5, 69, 1.5, 69, 1.5, 69, 1.5, 69],
				body: tableBody
			},
			layout: {
				paddingLeft: function (i, node) { return i === 0 ? 2 : 1; },
				paddingRight: function (i, node) { return i === 0 ? 2 : 1; },
				paddingTop: function (i, node) { return i === 0 ? 1 : 0.5; },
				paddingBottom: function (i, node) { return i === 0 ? 1 : 0.5; }
			},
			fontSize: 8,
			margin: [24, marginsTop, 8, 0]
		};
	}

	function getPumpsPage(data, insp) {
		if (getNestedProperty(insp, "inspectieDetails.Inspectie_details.GEEN_meting_uitgevoerd___visueel_afgekeurd") == true) {
			return;
		}

		function calculateVolume(inspection, cardData) {
			if (cardData) {
				// let kal_temp, kal_druk, meet_druk = 0;
				// let meet_temp = 0.00000001;
				// if (inspection && inspection.vezeltelling != undefined) {
				// 	if (isSet(inspection.vezeltelling.vezeltelling.Temperatuur_calibratie)) {
				// 		kal_temp = inspection.vezeltelling.vezeltelling.Temperatuur_calibratie;
				// 	}
				// 	if (isSet(inspection.vezeltelling.vezeltelling.Luchtdruk_calibratie)) {
				// 		kal_druk = inspection.vezeltelling.vezeltelling.Luchtdruk_calibratie;
				// 	}
				// 	if (isSet(inspection.vezeltelling.vezeltelling.Temperatuur_tijdens_meting)) {
				// 		meet_temp = inspection.vezeltelling.vezeltelling.Temperatuur_tijdens_meting;
				// 	}
				// 	if (isSet(inspection.vezeltelling.vezeltelling.Luchtdruk_tijdens_meting__mbar_)) {
				// 		meet_druk = inspection.vezeltelling.vezeltelling.Luchtdruk_tijdens_meting__mbar_;
				// 	}
				// }
				var factor = 1;// (kal_temp === 0 || kal_druk === 0 || meet_temp == undefined || meet_druk === 0) ? 0 : Math.sqrt((parseFloat(kal_druk) * (parseFloat(meet_temp) + 273.15) / (parseFloat(meet_druk) * (parseFloat(kal_temp) + 273.15))));;
				var flowGem = 0;
				var monsterVolume = "-";
				if (cardData.flowVoorLmin && cardData.flowNaLmin) {
					flowGem = (cardData.flowVoorLmin / 2 + cardData.flowNaLmin / 2)
				}
				if (flowGem != 0 && cardData.pomptijdMinuten && factor != 0) {
					monsterVolume = (flowGem * cardData.pomptijdMinuten * factor).toFixed(1);
				}
				return monsterVolume;
			}
			return "";

			function isSet(item) {
				return (item != undefined && item !== "");
			}
		}

		function calculateCorflowBefore(inspection, cardData) {
			if (cardData) {
				let kal_temp, kal_druk, meet_temp, meet_druk = 0;
				if (inspection && inspection.vezeltelling != undefined) {
					if (isSet(inspection.vezeltelling.vezeltelling.Temperatuur_calibratie)) {
						kal_temp = inspection.vezeltelling.vezeltelling.Temperatuur_calibratie;
					}
					if (isSet(inspection.vezeltelling.vezeltelling.Luchtdruk_calibratie)) {
						kal_druk = inspection.vezeltelling.vezeltelling.Luchtdruk_calibratie;
					}
					if (isSet(inspection.vezeltelling.vezeltelling.Temperatuur_tijdens_meting)) {
						meet_temp = inspection.vezeltelling.vezeltelling.Temperatuur_tijdens_meting;
					}
					if (isSet(inspection.vezeltelling.vezeltelling.Luchtdruk_tijdens_meting__mbar_)) {
						meet_druk = inspection.vezeltelling.vezeltelling.Luchtdruk_tijdens_meting__mbar_;
					}
				}
				var factor = 1; //(kal_temp == 0 || kal_druk == 0 || meet_temp == 0 || meet_druk == 0) ? 0 : Math.sqrt((parseFloat(kal_druk) * (parseFloat(meet_temp) + 273.15) / (parseFloat(meet_druk) * (parseFloat(kal_temp) + 273.15))));;

				var correctedFlowVoor = "-";
				if (cardData.flowVoorLmin) {
					correctedFlowVoor = (cardData.flowVoorLmin * factor).toFixed(1);
				}
				return correctedFlowVoor;
			}
			return "";
			function isSet(item) {
				return (item != undefined && item != "");
			}
		}

		function calculateCorflowAfter(inspection, cardData) {
			if (cardData) {
				let kal_temp, kal_druk, meet_temp, meet_druk = 0;
				if (inspection && inspection.vezeltelling != undefined) {
					if (isSet(inspection.vezeltelling.vezeltelling.Temperatuur_calibratie)) {
						kal_temp = inspection.vezeltelling.vezeltelling.Temperatuur_calibratie;
					}
					if (isSet(inspection.vezeltelling.vezeltelling.Luchtdruk_calibratie)) {
						kal_druk = inspection.vezeltelling.vezeltelling.Luchtdruk_calibratie;
					}
					if (isSet(inspection.vezeltelling.vezeltelling.Temperatuur_tijdens_meting)) {
						meet_temp = inspection.vezeltelling.vezeltelling.Temperatuur_tijdens_meting;
					}
					if (isSet(inspection.vezeltelling.vezeltelling.Luchtdruk_tijdens_meting__mbar_)) {
						meet_druk = inspection.vezeltelling.vezeltelling.Luchtdruk_tijdens_meting__mbar_;
					}
				}
				var factor = 1; //(kal_temp == 0 || kal_druk == 0 || meet_temp == 0 || meet_druk == 0) ? 0 : Math.sqrt((parseFloat(kal_druk) * (parseFloat(meet_temp) + 273.15) / (parseFloat(meet_druk) * (parseFloat(kal_temp) + 273.15))));;

				var correctedFlowNa = "-";
				if (cardData.flowNaLmin) {
					correctedFlowNa = (cardData.flowNaLmin * factor).toFixed(1);
				}
				return correctedFlowNa;
			}
			return "";
			function isSet(item) {
				return (item != undefined && item != "");
			}
		}


		function calculateConcBovengrens(inspection, cardData) {
			if (cardData) {
				const K1 =  463540.9;
				const poison_boven = [2.99, 5.5716, 7.2247, 8.7673, 10.242, 11.669, 13.06, 14.423, 15.764, 17.085, 18.391, 19.683, 20.962, 22.231, 23.49, 24.741, 25.983, 27.219, 28.448, 29.671, 30.889, 32.101, 33.309, 34.512, 35.711, 36.905, 38.097, 39.284, 40.468, 41.649, 42.827, 44.002, 45.175, 46.345, 47.512, 48.677, 49.84, 51, 52.158, 53.315, 54.469, 55.622, 56.772, 57.921, 59.068, 60.214, 61.358, 62.501, 63.642, 64.781, 65.919, 67.056, 68.192, 69.326, 70.459, 71.591, 72.721, 73.851, 74.979, 76.106, 77.232, 78.357, 79.482, 80.605, 81.727, 82.848, 83.969, 85.088, 86.207, 87.324, 88.441, 89.557, 90.673, 91.787, 92.901, 94.014, 95.126, 96.237, 97.348, 98.458, 99.567, 100.68, 101.79, 102.9, 104, 105.11, 106.21, 107.32, 108.42, 109.53, 110.63, 111.73, 112.83, 113.94, 115.04, 116.14, 117.24, 118.34, 119.44, 120.53, 121.66, 132.61, 143.52, 154.39, 165.23, 176.04, 186.83, 197.59, 208.33, 219.05, 229.75, 240.43, 251.1, 261.75, 272.39, 283.01, 293.62, 304.23, 314.82, 325.39, 335.96, 346.52, 357.08, 367.62, 378.15, 388.68, 399.2, 409.71, 420.22, 430.72, 441.21, 451.69, 462.18, 472.65, 483.12, 493.58, 504.04, 514.5, 524.95, 535.39];
				var concBovengrens = "";
				var roundedConcBovengrens = "-";
				var volumeLucht = calculateVolume(inspection, cardData);
				if (cardData.aantalGeteldeVezels !== "" && volumeLucht && volumeLucht !== "" && cardData.aantalGeteldeVelden) {
					concBovengrens = (poison_boven[cardData.aantalGeteldeVezels] * 1000 * K1) / ((volumeLucht * cardData.aantalGeteldeVelden * 10) + 0.00000001);
					var decimals = 1 - Math.floor(Math.log10(Math.abs(concBovengrens)));
					roundedConcBovengrens = decimals < 0 ?
						Math.round((concBovengrens / Math.pow(10, Math.abs(decimals)))) * Math.pow(10, Math.abs(decimals)) :
						concBovengrens.toFixed(Math.abs(decimals));
				}
				return roundedConcBovengrens;
			}
			return "";
		}

		
		function calculateConcOndergrens(inspection, cardData) {
			if (cardData) {
				const K1 = 463540.9;
				const poison_onder = [0, 0.0253, 0.2422, 0.6187, 1.0899, 1.6235, 2.2019, 2.8144, 3.4539, 4.1154, 4.7954, 5.4913, 6.2008, 6.9223, 7.6542, 8.3957, 9.1459, 9.9037, 10.668, 11.44, 12.217, 13, 13.788, 14.581, 15.378, 16.178, 16.983, 17.793, 18.606, 19.422, 20.241, 21.063, 21.888, 22.715, 23.545, 24.378, 25.213, 26.05, 26.89, 27.732, 28.575, 29.421, 30.269, 31.119, 31.97, 32.823, 33.678, 34.534, 35.392, 36.251, 37.112, 37.973, 38.837, 39.701, 40.567, 41.433, 42.301, 43.171, 44.041, 44.912, 45.785, 46.658, 47.533, 48.409, 49.286, 50.164, 51.042, 51.922, 52.803, 53.685, 54.567, 55.451, 56.335, 57.22, 58.106, 58.993, 59.88, 60.768, 61.657, 62.547, 63.437, 64.328, 65.219, 68.111, 67.003, 67.897, 68.79, 69.684, 70.579, 71.474, 72.37, 73.267, 74.164, 75.061, 75.959, 76.858, 77.757, 78.657, 79.557, 80.458, 81.36, 90.4, 99.49, 108.61, 117.77, 126.96, 136.17, 145.41, 154.66, 163.94, 173.24, 182.56, 191.89, 201.24, 210.6, 219.97, 229.36, 238.75, 248.16, 257.58, 267.01, 276.45, 285.9, 295.36, 304.82, 314.29, 323.77, 333.26, 342.75, 352.25, 361.76, 371.27, 380.79, 390.32, 399.85, 409.38, 418.92, 428.47, 438.02, 447.57];
				var concOndergrens = "";
				var roundedConcOndergrens = "";
				var volumeLucht = calculateVolume(inspection, cardData);
				if (cardData.aantalGeteldeVezels && volumeLucht && volumeLucht != "" && cardData.aantalGeteldeVelden) {
					concOndergrens = (poison_onder[cardData.aantalGeteldeVezels] * 1000 * K1) / ((volumeLucht * cardData.aantalGeteldeVelden * 10) + 0.00000001);
					var decimals = 1 - Math.floor(Math.log10(Math.abs(concOndergrens)));
					roundedConcOndergrens = decimals < 0 ?
						Math.round((concOndergrens / Math.pow(10, Math.abs(decimals)))) * Math.pow(10, Math.abs(decimals)) :
						concOndergrens.toFixed(Math.abs(decimals));
				}
				return roundedConcOndergrens;
			}
			return "";
		}
		function calculateConcentration(inspection, cardData) {
			if (cardData) {
				const K1 = 463540.9;
				var concentration = "";
				var roundedconcentration = "";
				var volumeLucht = calculateVolume(inspection, cardData);
				if (cardData.aantalGeteldeVezels && cardData.aantalGeteldeVelden && volumeLucht && volumeLucht != "") {
					concentration = (cardData.aantalGeteldeVezels * 1000 * K1) / ((volumeLucht * cardData.aantalGeteldeVelden * 10) + 0.00000001);
					var decimals = 1 - Math.floor(Math.log10(Math.abs(concentration)));
					roundedconcentration = decimals < 0 ?
						Math.round((concentration / Math.pow(10, Math.abs(decimals)))) * Math.pow(10, Math.abs(decimals)) :
						concentration.toFixed(Math.abs(decimals));
				}
				return roundedconcentration;
			}
			return "";
		}
		function calculateEindconcentratie(inspection, cardData) {
			if (cardData) {
				const K1 =  463540.9;
				const poison_boven = [2.99, 5.5716, 7.2247, 8.7673, 10.242, 11.669, 13.06, 14.423, 15.764, 17.085, 18.391, 19.683, 20.962, 22.231, 23.49, 24.741, 25.983, 27.219, 28.448, 29.671, 30.889, 32.101, 33.309, 34.512, 35.711, 36.905, 38.097, 39.284, 40.468, 41.649, 42.827, 44.002, 45.175, 46.345, 47.512, 48.677, 49.84, 51, 52.158, 53.315, 54.469, 55.622, 56.772, 57.921, 59.068, 60.214, 61.358, 62.501, 63.642, 64.781, 65.919, 67.056, 68.192, 69.326, 70.459, 71.591, 72.721, 73.851, 74.979, 76.106, 77.232, 78.357, 79.482, 80.605, 81.727, 82.848, 83.969, 85.088, 86.207, 87.324, 88.441, 89.557, 90.673, 91.787, 92.901, 94.014, 95.126, 96.237, 97.348, 98.458, 99.567, 100.68, 101.79, 102.9, 104, 105.11, 106.21, 107.32, 108.42, 109.53, 110.63, 111.73, 112.83, 113.94, 115.04, 116.14, 117.24, 118.34, 119.44, 120.53, 121.66, 132.61, 143.52, 154.39, 165.23, 176.04, 186.83, 197.59, 208.33, 219.05, 229.75, 240.43, 251.1, 261.75, 272.39, 283.01, 293.62, 304.23, 314.82, 325.39, 335.96, 346.52, 357.08, 367.62, 378.15, 388.68, 399.2, 409.71, 420.22, 430.72, 441.21, 451.69, 462.18, 472.65, 483.12, 493.58, 504.04, 514.5, 524.95, 535.39];
				var concBovengrens = "";
				var roundedConcBovengrens = "-";
				var volumeLucht = calculateVolume(inspection, cardData);
				if (cardData.aantalGeteldeVezels !== "" && volumeLucht && volumeLucht !== "" && cardData.aantalGeteldeVelden) {
					concBovengrens = (poison_boven[cardData.aantalGeteldeVezels] * 1000 * K1) / ((volumeLucht * cardData.aantalGeteldeVelden * 10) + 0.00000001);
					var decimals = 1 - Math.floor(Math.log10(Math.abs(concBovengrens)));
					roundedConcBovengrens = decimals < 0 ?
						Math.round((concBovengrens / Math.pow(10, Math.abs(decimals)))) * Math.pow(10, Math.abs(decimals)) :
						concBovengrens.toFixed(Math.abs(decimals));
				}
				let eindconcentratie = "";
				if (roundedConcBovengrens == "-" ||  concBovengrens >= 10000){
					eindconcentratie = roundedConcBovengrens;
				}
				else {
					eindconcentratie = "< 10000";
				}
				return eindconcentratie;
			}
			return "";
		}


		var pompenData = [];
		if (insp.pompen) {
			//let pumpsToDisplay = (insp.pompen.filter(e => e.pompnummer == 16 || e.pompnummer == 17 || e.pompnummer == 18 || e.pompnummer == 19 || e.pompnummer == 20).length > 0) ? 20 : 15;
			for (var i = 0; i < 20; i++) {
				var pompData = [];				
				insp.pompen.forEach((pump, index) => {
					{
						if (pump.pompnummer == (i + 1) && pump.Duplo_ != true) {
							pompData = [
								pump.filteroverbeladenSEM,
								pump.aantalGeteldeVelden,
								pump.pomptijdMinuten,
								calculateCorflowBefore(insp, pump),
								calculateCorflowAfter(insp, pump),
								calculateVolume(insp, pump),
								pump.aantalGeteldeVezels,
								calculateConcentration(insp, pump),
								calculateConcOndergrens(insp, pump),
								calculateConcBovengrens(insp, pump),
								calculateEindconcentratie(insp, pump)
							];
						}
					}

				});
				pompenData.push(pompData);
			}
		}

		const bottomTableData = [
			['Gemiddelde vezelconcentratie (vezels/m³) ', resultData.gemVezelConc],
			['Ondergrens (vezels/m³) ', resultData.ondergrens],
			['Bovengrens (vezels/m³)', resultData.bovengrens],
			['Eindconcentratie (vezels/m³)', resultData.eindconcentratie],
			['Toetsing overlap ', resultData.toetsingOverlap]
			// ,
			// ['Debietcorrectie toegepast?', 'JA']
		];
		const bottomTableBody = bottomTableData.map((row) => {
			return row.map((cell, idx) => {
				if (idx === 0) return { text: cell };
				return { text: cell, alignment: 'center' };
			});
		});
		var timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
		return [
			{
				pageBreak: 'before',
				columns: [
					{
						width: '50%',
						columns: [
							{
								width: 128,
								stack: [
									// { text: 'Temperatuur (°C)' },
									// { text: 'Luchtdruk (mbar)', margin: [0, 4, 0, 0] },
									{ text: 'Starttijd meting', margin: [0, 4, 0, 0] },
									{ text: 'Filters homogeen beladen?', margin: [0, 4, 0, 0] },
									{ text: 'Resolutie v/d microscoop ok?', margin: [0, 4, 0, 0] }
								]
							},
							{
								width: '*',
								stack: [
									// { text: getNestedProperty(insp, "vezeltelling.vezeltelling.Temperatuur_tijdens_meting") },
									// { text: getNestedProperty(insp, "vezeltelling.vezeltelling.Luchtdruk_tijdens_meting__mbar_"), margin: [0, 4, 0, 0] },
									{
										text: (getNestedProperty(insp, "vezeltelling.vezeltelling.Starttijd_meting") ?
											new Date(getNestedProperty(insp, "vezeltelling.vezeltelling.Starttijd_meting")).toLocaleTimeString('nl-NL', timeOptions) : "")
										, margin: [0, 4, 0, 0]
									},
									{ text: getNestedProperty(insp, "vezeltelling.vezeltelling.Zijn_de_filters_homogeen_beladen_") == true ? "Ja" : "Nee", margin: [0, 4, 0, 0] },
									{ text: getNestedProperty(insp, "vezeltelling.vezeltelling.Resolutie_v_d__microscoop_OK_") == true ? "Ja" : "Nee", margin: [0, 4, 0, 0] }
								]
							}
						],
						fontSize: 8,
						margin: [27, -2, 0, 0],
					},
					{
						width: '50%',
						columns: [
							{
								width: 98,
								stack: [
									{ text: 'RPS Projectnummer' },
									{ text: 'RPS Monsternummer', margin: [0, 4, 0, 0] }
								]
							},
							{
								width: '*',
								stack: [
									{ text: getNestedProperty(insp, "Inspectie_info.inspectieInfo.rPSProjectnummer") },
									{ text: getNestedProperty(insp, "inspectieDetails.Inspectie_details.rPSMonsternummer"), margin: [0, 4, 0, 0] }
								]
							}
						],
						fontSize: 8,
						margin: [0, -2, 0, 0],
					}
				]
			},
			getPumpTableRow(1, pompenData.slice(0, 5), 10.5, insp),
			getPumpTableRow(6, pompenData.slice(5, 10), 3.5, insp),
			getPumpTableRow(11, pompenData.slice(10, 15), 3.5, insp),
			getPumpTableRow(16, pompenData.slice(15, 20), 3.5, insp),
			{
				table: {
					headerRows: 0,
					widths: [204, 151],
					body: bottomTableBody
				},
				layout: {
					paddingLeft: function (i, node) { return 1; },
					paddingRight: function (i, node) { return 1; },
					paddingTop: function (i, node) { return 0.5; },
					paddingBottom: function (i, node) { return 0.5; }
				},
				fontSize: 8,
				margin: [24, 8.5, 8, 0]
			},
			{
				text: 'Voor de monsterneming en microscopie is gebruik gemaakt van de volgende instrumenten:',
				style: 'pump-remark-text', margin: [24, 13, 40, 0]
			},
			{
				text: '- Monsternamepomp met instelbare flow',
				style: 'pump-remark-text', margin: [24, 0, 40, 0]
			},
			{
				text: '- Open filterhouder met een cirkelvormig oppervlak van ten minste 20 mm. Als alternatief kunnen wegwerpfiltercassettes worden gebruikt. Deze zijn zowel leverbaar met cellulose-ester-filters (lichtmicroscopie) als met polycarbonaat kernporie-filters (SEM/EDX).',
				style: 'pump-remark-text', margin: [24, 0, 40, 0]
			},
			{
				text: '- Membraanfilters (MCE) met een poriëngrootte tussen 0,8 µm en 1,2 µm met opgedrukte vierkanten en een middellijn van 25 mm',
				style: 'pump-remark-text', margin: [24, 0, 40, 0]
			},
			{
				text: '- Lichtmicroscoop met fase-contrastbelichting',
				style: 'pump-remark-text', margin: [24, 0, 40, 0]
			}
		];
	}

	function getImageContextRender(data, img, isPageBrake, custContextText) {
		const ctx = (data && data.imagesContextIndex && img)
			? data.imagesContextIndex[img.id]
			: '';
		const text = (custContextText ? custContextText :
			(ctx ? ctx : img ? 'images' : ''));
		return {
			pageBreak: isPageBrake ? 'before' : '',
			text: text,
			alignment: "left",
			fontSize: 8,
			margin: [0, 10, 0, 5]
		};
	}

	function getImageDescription(img) {
		let descr = img.description;
		return {
			text: descr,
			fontSize: 8,
			alignment: "left",
			margin: [0, 10, 0, 5]
		}
	}

	function getImageRender(img, fit, isPageBrake, isDrawing) {
		const image = img && img.dataUrl ? img.dataUrl : null;
		if (img) {
			return {
				pageBreak: isPageBrake ? 'before' : '',
				image: image,
				fit: fit,
				alignment: isDrawing ? "center" : "left",
				margin: isDrawing ? [0, 5, 0, 0] : [0, 15, 0, 0]
			};
		}
		return [];
	}

	function getImagePreviewPage(data) {
		if (!data || !data.images || (data.images && data.images.length < 1)) return [];
		const fit = [a4[0] * 0.34, a4[1] * 0.20];
		const imagesToShow = [];
		let vooraanzichtAdded = false;
		let inspContainmentAdded = false;
		let deconUnitAdded = false;
		let klimmatAdded = false;
		data.images.forEach((i, idx) => {
			if (data.imagesContextIndex[i.id] == "visueleInspectie.Vooraanzicht_pand_terrein") {
				if (!vooraanzichtAdded) {
					imagesToShow.push({
						ctx: getImageContextRender(data, i, false, "Vooraanzicht pand terrein"),
						img: getImageRender(i, fit)
					});
					vooraanzichtAdded = true;
				}
			}
			if (data.imagesContextIndex[i.id] == "visueleInspectie.Inspectiegebied_Containment") {
				if (!inspContainmentAdded) {
					imagesToShow.push({
						ctx: getImageContextRender(data, i, false, "Inspectiegebied Containment"),
						img: getImageRender(i, fit)
					});
					inspContainmentAdded = true;
				}
			}
			if (data.imagesContextIndex[i.id] == "visueleInspectie.Decontaminatie_unit") {
				if (!deconUnitAdded) {
					imagesToShow.push({
						ctx: getImageContextRender(data, i, false, "Decontaminatie unit"),
						img: getImageRender(i, fit)
					});
					deconUnitAdded = true;
				}
			}
			if (data.imagesContextIndex[i.id] == "visueleInspectie.Klimmateriaal_machine_werken_op_hoogte_") {
				if (!klimmatAdded) {
					imagesToShow.push({
						ctx: getImageContextRender(data, i, false, "Klimmateriaal machine werken op hoogte"),
						img: getImageRender(i, fit)
					});
					klimmatAdded = true;
				}
			}
		});

		const body = Array.from(Array(2)).reduce((acc, cur, idx) => {
			const i = idx * 2;
			acc.push([
				imagesToShow[i] ? imagesToShow[i].img : getImageRender(null, fit),
				imagesToShow[i + 1] ? imagesToShow[i + 1].img : getImageRender(null, fit)
			]);
			acc.push([
				imagesToShow[i] ? imagesToShow[i].ctx : getImageContextRender(data),
				imagesToShow[i + 1] ? imagesToShow[i + 1].ctx : getImageContextRender(data)
			]);

			return acc;
		}, []);

		const pageRender = {
			table: {
				headerRows: 0,
				widths: ['50%', '50%'],
				body: body
			},
			layout: 'noBorders',
			margin: [30, 0, 0, 0]
		};

		return pageRender;
	}

	function getAllImages(data) {
		if (!data || !data.images || data.images.length < 1) return [];

		const fit = [a4[0] * 0.38, a4[1] * 0.25]; //[a4[0] * 0.34, a4[1] * 0.20];
		const reportImages = data.inspection.not_in_report_images ?
			data.images.filter(s => data.inspection.not_in_report_images.indexOf(s.id) < 0) : data.images;

		const overviewImages = [
			'visueleInspectie.Vooraanzicht_pand_terrein',
			'visueleInspectie.Inspectiegebied_Containment',
			'visueleInspectie.Decontaminatie_unit',
			'visueleInspectie.Klimmateriaal_machine_werken_op_hoogte_'
		];
		const finalImages = reportImages.filter(i => overviewImages.indexOf(data.imagesContextIndex[i.id]) === -1).sort((a, b) => (a.id > b.id) ? 1 : -1);
		if (finalImages.length < 1) {
			return [];
		}
		const body = [];
		let row = 0, col = 0;
		finalImages.sort((s, t) => (s.propertyName > t.propertyName) ? 1 : -1).forEach((img) => {
			if (body[row] == undefined) {
				body[row] = [[], []];
			}

			const isPageBrake = (row % 3 === 0);
			// body[row][col].push(getImageContextRender(data, img, isPageBrake, img.propertyName));

			body[row][col].push(getImageRender(img, fit, isPageBrake));
			body[row][col].push(getImageDescription(img));
			col++;
			if (col > 1) {
				col = 0;
				row++;
			}
		});

		const pageRender = {
			table: {
				headerRows: 0,
				widths: ['50%', '35%'],
				body: body
			},
			layout: 'noBorders',
			margin: [25, 0, 0, 0]
		};
		return pageRender;
	}

	function getAllDrawings(data) {
		if (!data || !data.images || !data.drawings || (data.drawings.length < 1)) return [];
		function drawingTitle(indx, length) {
			const drawingTitle =
			{
				text: 'Situatieschets ' + (indx + 1) + ' - ' + length,
				alignment: 'center',
				fontSize: 14,
				bold: true,
				color: '#000000',
				margin: [15, 5, 0, 0],
				pageBreak: 'before'

			};
			return drawingTitle;
		}
		const fit = [a4[0] * 0.90, a4[1] * 0.82];
		let reportDrawings = data.inspection.not_in_report_images
			? data.drawings.filter(d => data.inspection.not_in_report_images.indexOf(d.id) < 0)
			: data.drawings;
		reportDrawings = reportDrawings.filter(d => d.propertyName !== 'signature')
			.sort((s, t) => (s.propertyName > t.propertyName) ? 1 : -1);

		var drawPagesRender = [];
		for (var i = 0; i < reportDrawings.length; i++) {
			drawPagesRender.push(drawingTitle(i, reportDrawings.length));
			drawPagesRender.push(getImageRender(reportDrawings[i], fit, false, true));
		}

		return [
			drawPagesRender
		];
	}

	function getContent(data) {
		if (data.inspection._canceled){
			const content = [
				getFirtsPageTop(data, data.inspection),
				getFirtsPageMiddle(data.inspection),
			    getFirstPageTables(data.inspection),
		      	getFirstPageBottom(data, data.inspection),
				getAllImages(data, data.inspection),
				getAllDrawings(data)
			]
			return content;
		}		
		const content = [
			getFirtsPageTop(data, data.inspection),
			getFirtsPageMiddle(data.inspection),
			getFirstPageTables(data.inspection),
			getFirstPageBottom(data, data.inspection),
			getRandvoorwaardenPage(data.inspection),
			getImagePreviewPage(data),
			getVisualInspectionPage(data.inspection),
			getSegmentsPages(data.inspection),
			getPumpsPage(data, data.inspection),
			getAllImages(data, data.inspection),
			getAllDrawings(data)
		];
		return content;
	}

	function getDocumentDefinition(data) {
		const docDefinition = {
			pageSize: "A4",
			pageOrientation: "portrait",
			pageMargins: [10, 60, 10, 55], //[left, top, right, bottom]
			info: {
				title: "RPS REPORT",
				author: "john doe",
				subject: "subject of document",
				keywords: "keywords for document",
				producer: "Traiectum Digital Solutions",
				creationDate: new Date(),
				modDate: new Date()
			},
			header: getHeader,
			footer: getFooter,
			content: getContent(data),
			styles: {
				'gray-header': {
					fontSize: 11,
					bold: true,
					color: '#808080'
				},
				'gray-text': {
					fontSize: 8,
					bold: false,
					color: '#808080'
				},
				'segment-header': {
					fontSize: 11,
					bold: true,
				},
				'text': {
					fontSize: 8,
					bold: false,
					color: '#000000'
				},
				'pump-remark-text': {
					fontSize: 8,
					lineHeight: 0.9
				},
				'link': {
					color: '#0000FF',
					decoration: 'underline'
				},
				'footer-link': { color: '#04129E' },
			},
			images: { rpsLogo: rpsLogo() }
		};

		return docDefinition;
	}

	return getDocumentDefinition(d);

	function rpsLogo() {
		//Width:	98 px
		//Height:	52 px
		return "data:image/jpeg;base64," +
			"iVBORw0KGgoAAAANSUhEUgAAAZQAAACHCAYAAAAx8K8hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAABQnSURBVHhe7Z1BqyZHFYb9U / 4KF / kF4kJXgkEXwYXBjQSG2biIzEIIMiIEkRFBRO9CkSEoMosoIZAQkGggxMAwmU0yuyvvzHdm3ltzqrq6u6r7dPX7wEvmdvfXX / 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"
	};


	//file: RPS-calculation version 1.1 used in RPS inspection types

	function RPSCalculation(d) {
		let inspection = d.inspection;
		var ResultData = generateCalculationObject(inspection);

		function generateCalculationObject(inspection) {

			//IMPORTANT! IMPLEMENT CORRECTION FOR DIVIDING BY 0. (use for instance 0.0000001)
			let validationErrors = [];
	
			//inspection card variables (input fields)
			let kal_temp = inspection.vezeltelling == undefined || inspection.vezeltelling.vezeltelling.Temperatuur_calibratie == undefined || inspection.vezeltelling.vezeltelling.Temperatuur_calibratie === "" ?
				0 : inspection.vezeltelling.vezeltelling.Temperatuur_calibratie;
			let kal_druk = inspection.vezeltelling == undefined || inspection.vezeltelling.vezeltelling.Luchtdruk_calibratie == undefined || inspection.vezeltelling.vezeltelling.Luchtdruk_calibratie === "" ?
				0 : inspection.vezeltelling.vezeltelling.Luchtdruk_calibratie;
			let meet_temp = inspection.vezeltelling == undefined || inspection.vezeltelling.vezeltelling.Temperatuur_tijdens_meting == undefined || inspection.vezeltelling.vezeltelling.Temperatuur_tijdens_meting === "" ?
				0 : inspection.vezeltelling.vezeltelling.Temperatuur_tijdens_meting;
			let meet_druk = inspection.vezeltelling == undefined || inspection.vezeltelling.vezeltelling.Luchtdruk_tijdens_meting__mbar_ == undefined || inspection.vezeltelling.vezeltelling.Luchtdruk_tijdens_meting__mbar_ === "" ?
				0 : inspection.vezeltelling.vezeltelling.Luchtdruk_tijdens_meting__mbar_;
	
	
			//constants
			const poison_onder = [0, 0.0253, 0.2422, 0.6187, 1.0899, 1.6235, 2.2019, 2.8144, 3.4539, 4.1154, 4.7954, 5.4913, 6.2008, 6.9223, 7.6542, 8.3957, 9.1459, 9.9037, 10.668, 11.44, 12.217, 13, 13.788, 14.581, 15.378, 16.178, 16.983, 17.793, 18.606, 19.422, 20.241, 21.063, 21.888, 22.715, 23.545, 24.378, 25.213, 26.05, 26.89, 27.732, 28.575, 29.421, 30.269, 31.119, 31.97, 32.823, 33.678, 34.534, 35.392, 36.251, 37.112, 37.973, 38.837, 39.701, 40.567, 41.433, 42.301, 43.171, 44.041, 44.912, 45.785, 46.658, 47.533, 48.409, 49.286, 50.164, 51.042, 51.922, 52.803, 53.685, 54.567, 55.451, 56.335, 57.22, 58.106, 58.993, 59.88, 60.768, 61.657, 62.547, 63.437, 64.328, 65.219, 68.111, 67.003, 67.897, 68.79, 69.684, 70.579, 71.474, 72.37, 73.267, 74.164, 75.061, 75.959, 76.858, 77.757, 78.657, 79.557, 80.458, 81.36, 90.4, 99.49, 108.61, 117.77, 126.96, 136.17, 145.41, 154.66, 163.94, 173.24, 182.56, 191.89, 201.24, 210.6, 219.97, 229.36, 238.75, 248.16, 257.58, 267.01, 276.45, 285.9, 295.36, 304.82, 314.29, 323.77, 333.26, 342.75, 352.25, 361.76, 371.27, 380.79, 390.32, 399.85, 409.38, 418.92, 428.47, 438.02, 447.57];
			const poison_boven = [2.99, 5.5716, 7.2247, 8.7673, 10.242, 11.669, 13.06, 14.423, 15.764, 17.085, 18.391, 19.683, 20.962, 22.231, 23.49, 24.741, 25.983, 27.219, 28.448, 29.671, 30.889, 32.101, 33.309, 34.512, 35.711, 36.905, 38.097, 39.284, 40.468, 41.649, 42.827, 44.002, 45.175, 46.345, 47.512, 48.677, 49.84, 51, 52.158, 53.315, 54.469, 55.622, 56.772, 57.921, 59.068, 60.214, 61.358, 62.501, 63.642, 64.781, 65.919, 67.056, 68.192, 69.326, 70.459, 71.591, 72.721, 73.851, 74.979, 76.106, 77.232, 78.357, 79.482, 80.605, 81.727, 82.848, 83.969, 85.088, 86.207, 87.324, 88.441, 89.557, 90.673, 91.787, 92.901, 94.014, 95.126, 96.237, 97.348, 98.458, 99.567, 100.68, 101.79, 102.9, 104, 105.11, 106.21, 107.32, 108.42, 109.53, 110.63, 111.73, 112.83, 113.94, 115.04, 116.14, 117.24, 118.34, 119.44, 120.53, 121.66, 132.61, 143.52, 154.39, 165.23, 176.04, 186.83, 197.59, 208.33, 219.05, 229.75, 240.43, 251.1, 261.75, 272.39, 283.01, 293.62, 304.23, 314.82, 325.39, 335.96, 346.52, 357.08, 367.62, 378.15, 388.68, 399.2, 409.71, 420.22, 430.72, 441.21, 451.69, 462.18, 472.65, 483.12, 493.58, 504.04, 514.5, 524.95, 535.39];
			const D = 21.53;
			const d = 100;
			const n = 100;
			const K1 = 1000000000 * D * D / (n * d * d);
			const Factor = 1; //calcFactor();
			const prevDivByZero = 0.0000000000001;
	
			//intermediate values
			let n2 = countAverageFieldsPerPomp();
			//let pompVeldenGelijkAanGemiddelde = isFieldAverageEqualToFieldsPerPomp();
			let K2 = ((3.14159 * D * D) / 4) / (0.007853982 * n2);
			let somGeteldeVezels = countTotalVezels();
			let somGetVezelsPoisonLookUp = somGeteldeVezels < 101 ? somGeteldeVezels : Math.round(((somGeteldeVezels - 100) / 10) + 100);
			let somVolume = countTotalVolume();
			let somAfwijkingVolumeVeldenVolume = countAfwijkingVolumeAndFieldVolume();
			let NMaxOndergrens = getMaxOndergrens();
			let NMaxBovengrens = getMaxBovengrens();
	
			//results (output fields)	
			let gemVezelConc = somGeteldeVezels === 0 || K2 === 0 || somVolume === "" ? "-" : customRound(((somGeteldeVezels * K2 / (somVolume + prevDivByZero))), (1 - Math.floor(Math.log10(Math.abs((somGeteldeVezels * K2 / (somVolume + prevDivByZero))))))).toFixed(0);
			let ondergrens = somGeteldeVezels === 0 || K2 === 0 || somVolume === "" ? "-" : customRound((poison_onder[Math.round(somGetVezelsPoisonLookUp)] * K2 / (somVolume + prevDivByZero)),(1 - Math.floor(Math.log10(Math.abs((poison_onder[Math.round(somGetVezelsPoisonLookUp)] * K2 / (somVolume + prevDivByZero))))))).toFixed(0);
			let bovengrens = K2 === 0 || somVolume === "" || somVolume == 0 ? "-" : customRound((poison_boven[Math.round(somGetVezelsPoisonLookUp)] * K2 / (somVolume + prevDivByZero)), (1 - Math.floor(Math.log10(Math.abs((poison_boven[Math.round(somGetVezelsPoisonLookUp)] * K2 / (somVolume + prevDivByZero))))))).toFixed(0);
			let aantalConcBovengrens = countTotConcBovengrens();
			let toetsingOverlap = NMaxBovengrens > NMaxOndergrens ? "Ja" : "Nee";
			let eindconcentratie = calcEindconcentratie();
			let geteld = somVolume;
			let debietCorrectie = Factor;
	
	
			//functions used to calculate fields
	
			function customRound(x, places) //mimic Excel-rounding to negative decimal locations
			{
				var shift = Math.pow(10, places);
				return Math.round(x * shift) / shift;
			}
	
			function countTotalVezels() {
				if (inspection.pompen != undefined) {
					let totVezels = 0;
					for (let p of inspection.pompen) {
						if (p) {
							if (p.Duplo_ != true) {
								if (p.aantalGeteldeVezels != undefined && p.aantalGeteldeVezels !== "") {
									totVezels += parseInt(p.aantalGeteldeVezels);
								} else {
									totVezels += 0;
									validationErrors.push({ error: "Aantal getelde vezels niet ingevuld", path: "inspection.pompen" });
								}
							}
						}
					}
					return totVezels;
				}
			}
	
			function countTotalVolume() {
				if (inspection.pompen != undefined) {
					let totVolume = 0;
					for (let p of inspection.pompen) {
						if (p) {
							if (p.Duplo_ != true) {
								if (p.aantalGeteldeVezels == undefined || p.aantalGeteldeVezels === "") {
									totVolume += 0;
								} else {
									var flowGem = 0;
									if (p.flowNaLmin == undefined || p.flowNaLmin === "") {
										flowGem = "";
										validationErrors.push({ error: "Flow Na niet ingevuld", path: "inspection.pompen" })
									} else if (p.flowVoorLmin == undefined || p.flowVoorLmin === "") {
										flowGem = "";
										validationErrors.push({ error: "Flow Voor niet ingevuld", path: "inspection.pompen" })
									} else if (p.flowNaLmin != undefined && p.flowVoorLmin != undefined) {
										flowGem = ((Number(p.flowNaLmin) / 2) + (Number(p.flowVoorLmin) / 2))
									}
									var monsterVolume = 0;
									if (flowGem === "") {
										monsterVolume = "";
										return monsterVolume;
									} else if (p.pomptijdMinuten == undefined || p.pomptijdMinuten === "") {
										validationErrors.push({ error: "Pomptijd niet ingevuld", path: "inspection.pompen" })
										monsterVolume = "";
										return monsterVolume;
									} else if (p.pomptijdMinuten != undefined) {
										monsterVolume = p.pomptijdMinuten * flowGem * Factor;
									}
									totVolume += monsterVolume;
								}
							}
						}
					}
					return (totVolume / 1000);//in m3
				}
			}
	
			function countAverageFieldsPerPomp() {
				if (inspection.pompen != undefined) {
					let totAantalVelden = 0;
					let duploPresent = false;
					for (let p of inspection.pompen) {
						if (p) {
							if (p.Duplo_ == true) {
								duploPresent = true;
							}
							if (p.Duplo_ != true) {
								if (p.aantalGeteldeVelden != undefined) {
									totAantalVelden += parseInt(p.aantalGeteldeVelden);
								} else if (p.aantalGeteldeVelden == undefined || p.aantalGeteldeVelden === "") {
									validationErrors.push({ error: "Aantal getelde velden niet ingevuld", path: "inspection.pompen" })
								}
							}
						}
					}
					let amountOfPompen = inspection.pompen.filter(p => p != undefined).length;
					let totAantalVeldenPerPomp = (totAantalVelden / (duploPresent ? (amountOfPompen - 1) : amountOfPompen));
	
					return totAantalVeldenPerPomp;
				}
			}
	
			// function isFieldAverageEqualToFieldsPerPomp() {
			// 	let fieldAverageEqualToFieldsPerPomp = true;
			// 	if (inspection.pompen != undefined) {
			// 		for (let p of inspection.pompen) {
			// 			if (p) {
			// 				if (p.Duplo_ != true) {
			// 					if (p.aantalGeteldeVelden != n2) {
			// 						fieldAverageEqualToFieldsPerPomp = false;
			// 					}
			// 				}
			// 			}
			// 		}
			// 		return fieldAverageEqualToFieldsPerPomp;
			// 	}
			// }
	
			//counts concentration upper limit above 0.01 for all pumps
			function countTotConcBovengrens() {
				if (inspection.pompen != undefined) {
					let totConcBovengrens = 0;
					for (let p of inspection.pompen) {
						if (p) {
							if (p.Duplo_ != true) {
								var aantalVezelsBovengrens = p.aantalGeteldeVezels === "" ? "" : poison_boven[Math.round(p.aantalGeteldeVezels)];
								var flowGem = p.flowNaLmin === "" ? "" : (p.flowVoorLmin / 2) + (p.flowNaLmin / 2);
								var monstervolume = flowGem === "" || Factor === 0 || p.pomptijdMinuten === "" || p.pomptijdMinuten == undefined ? "" : flowGem * p.pomptijdMinuten * Factor;
								var concBovengrens = aantalVezelsBovengrens === "" || monstervolume === "" || monstervolume === 0 || p.aantalGeteldeVelden === 0 ? "" : ((aantalVezelsBovengrens * 1000 * K1) / (monstervolume * p.aantalGeteldeVelden * 10))
									.toFixed(Math.abs(1 - Math.floor(Math.log10(Math.abs(((aantalVezelsBovengrens * 1000 * K1) / (monstervolume * p.aantalGeteldeVelden * 10)))))));
								if (concBovengrens > 10000) {
									totConcBovengrens += 1;
								}
							}
	
						}
					}
					return totConcBovengrens;
				}
			}
	
			function countAfwijkingVolumeAndFieldVolume() {
				if (inspection.pompen != undefined) {
					let totAfwFieldVolumeAndVezelMissmatch = 0;
					let totAfwijking10percent = 0;
					let totVezelsAndVolumeMissmatch = 0;
					let totFieldVolume = 0;
					for (let p of inspection.pompen) {
						if (p) {
							if (p.Duplo_ != true) {
								if (p.flowNaLmin != undefined && p.flowVoorLmin != undefined) {
									if (((p.flowVoorLmin / p.flowNaLmin) < 0.9) || ((p.flowVoorLmin / p.flowNaLmin) > 1.1)) {
										totAfwijking10percent += 1;
									}
									var flowgem = (p.flowVoorLmin / 2) + (p.flowNaLmin / 2);
									var monsterVolume = flowgem * p.pomptijdMinuten * Factor;
									if (monsterVolume < 959 && p.aantalGeteldeVelden == 100) {
										totFieldVolume += 1;
									}
									if ((monsterVolume == 0 && (p.aantalGeteldeVezels != undefined && p.aantalGeteldeVezels != ""))
										|| (monsterVolume != 0 && (p.aantalGeteldeVezels == undefined || p.aantalGeteldeVezels === ""))
									) {
										totVezelsAndVolumeMissmatch += 1;
									}
	
								}
							}
						}
					}
					totAfwFieldVolumeAndVezelMissmatch = totAfwijking10percent + totFieldVolume + totVezelsAndVolumeMissmatch;
					return totAfwFieldVolumeAndVezelMissmatch;
				}
			}
	
			function getMaxOndergrens() {
				var maxOnd;
				if (inspection.pompen != undefined) {
					var ondergrenzen = [];
					for (let p of inspection.pompen) {
						if (p) {
							if (p.Duplo_ != true) {
								if (p.flowNaLmin == undefined || p.flowNaLmin === "" || p.flowVoorLmin == undefined || p.flowVoorLmin === "") {
									maxOnd = "-";
									return maxOnd;
								} else if (p.flowNaLmin != undefined && p.flowVoorLmin != undefined) {
									var flowgem = (p.flowVoorLmin / 2) + (p.flowNaLmin / 2);
									var monsterVolume = flowgem * p.pomptijdMinuten * Factor;
									if (monsterVolume > 0 && p.aantalGeteldeVezels != undefined) {
										var aantalVezelsOndergrens = p.aantalGeteldeVezels === "" ? "" : poison_onder[Math.round(p.aantalGeteldeVezels)];
										var onder = ((aantalVezelsOndergrens * K1) / monsterVolume);
										ondergrenzen.push(onder);
									}
								}
							}
							maxOnd = Math.max(...ondergrenzen);
						}
					}
					return maxOnd;
				}
			}
	
			function getMaxBovengrens() {
				var maxBov;
				if (inspection.pompen != undefined) {
					var bovengrenzen = [];
					for (let p of inspection.pompen) {
						if (p) {
							if (p.Duplo_ != true) {
								if (p.flowNaLmin == undefined || p.flowNaLmin === "" || p.flowVoorLmin == undefined || p.flowVoorLmin === "") {
									maxBov = "-";
									return maxBov;
								}
								if (p.flowNaLmin != undefined && p.flowVoorLmin != undefined) {
									var flowgem = (p.flowVoorLmin / 2) + (p.flowNaLmin / 2);
									var monsterVolume = flowgem * p.pomptijdMinuten * Factor;
									if (monsterVolume > 0 && p.aantalGeteldeVezels != undefined) {
										var aantalVezelsBovengrens = p.aantalGeteldeVezels === "" ? "" : poison_boven[Math.round(p.aantalGeteldeVezels)];
										var boven = ((aantalVezelsBovengrens * K1) / monsterVolume);
										bovengrenzen.push(boven);
									}
								}
							}
							maxBov = Math.min(...bovengrenzen);
	
						}
					}
					return maxBov;
				}
			}
	
			function calcEindconcentratie() {
				var eindconcentratie = "";
				if (aantalConcBovengrens < 1 && somAfwijkingVolumeVeldenVolume < 1) {
					eindconcentratie = "<10000";
					return eindconcentratie;
				} else if (aantalConcBovengrens >= 1 && toetsingOverlap === "Ja" && somAfwijkingVolumeVeldenVolume < 1) {
					eindconcentratie = bovengrens < 10000 ? "<10000" : bovengrens;
					return eindconcentratie;
				} else {
					eindconcentratie = "Geen middeling mogelijk";
					return eindconcentratie;
				}
			}
	
			function calcFactor() {
				var isUndefined = false;
				var F = "";
				if (kal_temp === 0 || kal_temp == undefined) {
					isUndefined = true;
					validationErrors.push({ error: "Kalibratie temperatuur niet ingevuld", path: "inspection.vezeltelling" })
				}
				if (kal_druk === 0 || kal_druk == undefined) {
					isUndefined = true;
					validationErrors.push({ error: "Kalibratie druk niet ingevuld", path: "inspection.vezeltelling" })
				}
				if (meet_temp == undefined) {
					isUndefined = true;
					validationErrors.push({ error: "Meet temperatuur niet ingevuld", path: "inspection.vezeltelling" })
				}
				if (meet_druk === 0 || meet_druk == undefined) {
					isUndefined = true;
					validationErrors.push({ error: "Meet druk niet ingevuld", path: "inspection.vezeltelling" })
				}
	
				if (!isUndefined) {
					F = Math.sqrt((kal_druk * (meet_temp + 273.15) / (meet_druk * (kal_temp + 273.15))));
				}
				return F;
			}
	
			var resultObj = {
				gemVezelConc,
				ondergrens,
				bovengrens,
				eindconcentratie,
				toetsingOverlap,
				aantalConcBovengrens,
				validationErrors,
				geteld,
				debietCorrectie
			};
	
			return resultObj;
	
		}
		return ResultData;

	}
}

